import * as React from "react";

import { Grid, MenuItem, Select, Typography } from "mpulse-design-system";

import MetadataStatus from "./../../utils/enums/MetadataStatus";
import constants from "../../constants";

const StatusFilterBox = ({
  status,
  setStatus,
  fetchFilter,
  setFetchingFilter,
  setFilterActive,
  resetFilterState,
}) => {
  const handleChange = (e) => {
    const value = `${e.target.value}`;
    resetFilterState(false);
    setStatus(value);
    setFetchingFilter(true);
    setFilterActive(true);
    fetchFilter({ status: value });
  };

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs>
        <Select
          value={status}
          displayEmpty
          onChange={handleChange}
          sx={{ width: "100%", minWidth: 192 }}
        >
          <MenuItem value="" disabled>
            <Typography variant="body1" color="textTertiary">
              Status
            </Typography>
          </MenuItem>
          <MenuItem value={1}>
            {constants.metadata.statuses[MetadataStatus.DRAFT]}
          </MenuItem>
          <MenuItem value={2}>
            {constants.metadata.statuses[MetadataStatus.PENDING_VOICE_TALENT]}
          </MenuItem>
          <MenuItem value={3}>
            {constants.metadata.statuses[MetadataStatus.READY_FOR_REVIEW]}
          </MenuItem>
          <MenuItem value={4}>
            {constants.metadata.statuses[MetadataStatus.IN_PUBLISH_QUEUE]}
          </MenuItem>
          <MenuItem value={5}>
            {constants.metadata.statuses[MetadataStatus.PUBLISHED]}
          </MenuItem>
          <MenuItem value={6}>
            {constants.metadata.statuses[MetadataStatus.ARCHIVED]}
          </MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default StatusFilterBox;
